import { render, staticRenderFns } from "./ModuleTitle.vue?vue&type=template&id=8cc6fe12&scoped=true&"
import script from "./ModuleTitle.vue?vue&type=script&lang=js&"
export * from "./ModuleTitle.vue?vue&type=script&lang=js&"
import style0 from "./ModuleTitle.vue?vue&type=style&index=0&id=8cc6fe12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cc6fe12",
  null
  
)

export default component.exports